import React, { useState } from 'react';
import Input from '../ui/Input';
import { AiOutlineSearch } from 'react-icons/ai';
import { HiMenuAlt3 } from "react-icons/hi";
import { FaTimes, FaFacebookF, FaTwitter, FaInstagram } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import { Link } from 'react-router-dom';

const Header = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const navigate = useNavigate();

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  const onSearch = () => {
    if (searchQuery.trim()) {
      navigate(`/search/${searchQuery}`);
      setSidebarOpen(false);
    }
  };

  const handleInputChange = (e) => {
    setSearchQuery(e.target.value);
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      onSearch();
    }
  };

  return (
    <>
      <div className='shadow-lg flex justify-between items-center px-4 py-3 sm:px-8 md:px-16 z-50 sticky top-0 bg-white/95 backdrop-blur-md border-b border-gray-100'>
        <Link to="/" className="flex items-center">
          <div className="bg-gradient-to-br from-[#DC2626] to-[#B91C1C] w-10 h-10 sm:w-12 sm:h-12 rounded-xl flex items-center justify-center shadow-lg hover:scale-105 transition-transform duration-300">
            <span className="text-white font-bold text-base sm:text-lg">GIGA</span>
          </div>
        </Link>

        {/* Desktop Navigation */}
        <div className='hidden md:flex'>
          <ul className='flex gap-6 sm:gap-8 items-center'>
            <Link to="/">
              <li className='hover:text-[#DC2626] cursor-pointer font-medium text-[15px] transition-colors duration-200 py-2 px-1 border-b-2 border-transparent hover:border-[#DC2626]'>Home</li>
            </Link>
            <Link to="/cars">
              <li className='hover:text-[#DC2626] cursor-pointer font-medium text-[15px] transition-colors duration-200 py-2 px-1 border-b-2 border-transparent hover:border-[#DC2626]'>Car Deals</li>
            </Link>
            <Link to="/rental">
              <li className='hover:text-[#DC2626] cursor-pointer font-medium text-[15px] transition-colors duration-200 py-2 px-1 border-b-2 border-transparent hover:border-[#DC2626]'>Rental</li>
            </Link>
            <Link to="/workshop">
              <li className='hover:text-[#DC2626] cursor-pointer font-medium text-[15px] transition-colors duration-200 py-2 px-1 border-b-2 border-transparent hover:border-[#DC2626]'>Workshop</li>
            </Link>
            <Link to="/blog/66c6eeef6fd2b5788b909128">
              <li className='hover:text-[#DC2626] cursor-pointer font-medium text-[15px] transition-colors duration-200 py-2 px-1 border-b-2 border-transparent hover:border-[#DC2626]'>About Us</li>
            </Link>
            <Link to="/blog/66c6f093dc2c7f86bdc18469">
              <li className='hover:text-[#DC2626] cursor-pointer font-medium text-[15px] transition-colors duration-200 py-2 px-1 border-b-2 border-transparent hover:border-[#DC2626]'>Contact Us</li>
            </Link>
          </ul>
        </div>

        {/* Desktop Search with Social Media Icons */}
        <div className='relative w-48 sm:w-64 md:w-96 hidden md:flex items-center gap-4'>
          <div className='relative w-full'>
            <Input
              type="text"
              placeholder='Search cars, models...'
              className='w-full shadow-sm'
              value={searchQuery}
              onChange={handleInputChange}
              onKeyDown={handleKeyDown}
            />
            <AiOutlineSearch 
              className='absolute top-1/2 right-4 transform -translate-y-1/2 text-gray-400 cursor-pointer hover:text-[#DC2626] transition-colors z-10' 
              size={20} 
              onClick={onSearch}
            />
          </div>
          {/* Social Media Icons */}
          <div className='flex justify-center gap-2'>
            <a href="https://www.facebook.com" target="_blank" rel="noopener noreferrer">
              <div className='bg-[#1877F2] p-2.5 rounded-full hover:bg-[#166fe5] transition-all duration-300 hover:scale-110 shadow-md'>
                <FaFacebookF className='text-white text-lg cursor-pointer' />
              </div>
            </a>
            <a href="https://www.twitter.com" target="_blank" rel="noopener noreferrer">
              <div className='bg-[#1DA1F2] p-2.5 rounded-full hover:bg-[#1a91da] transition-all duration-300 hover:scale-110 shadow-md'>
                <FaTwitter className='text-white text-lg cursor-pointer' />
              </div>
            </a>
            <a href="https://www.instagram.com" target="_blank" rel="noopener noreferrer">
              <div className='bg-gradient-to-r from-[#F58529] via-[#DD2A7B] to-[#833AB4] p-2.5 rounded-full hover:opacity-90 transition-all duration-300 hover:scale-110 shadow-md'>
                <FaInstagram className='text-white text-lg cursor-pointer' />
              </div>
            </a>
          </div>
        </div>

        {/* Mobile Menu Icon */}
        <div className='md:hidden'>
          <HiMenuAlt3 className='text-3xl cursor-pointer' onClick={toggleSidebar} />
        </div>
      </div>

      {/* Mobile Sidebar */}
      <div 
        className={`fixed inset-0 z-40 bg-black/60 backdrop-blur-sm transition-opacity ${sidebarOpen ? 'opacity-100 visible' : 'opacity-0 invisible'} md:hidden`} 
        onClick={toggleSidebar}
      ></div>
      <div className={`fixed top-0 right-0 w-[85%] sm:w-[70%] h-full bg-white shadow-2xl z-50 transform transition-transform duration-300 ease-in-out ${sidebarOpen ? 'translate-x-0' : 'translate-x-full'} md:hidden`}>
        <div className='flex justify-between items-center p-6 border-b border-gray-200 bg-gradient-to-r from-blue-50 to-white'>
          <Link to="/" className="flex items-center" onClick={toggleSidebar}>
            <div className="bg-gradient-to-br from-[#DC2626] to-[#B91C1C] w-10 h-10 rounded-xl flex items-center justify-center shadow-lg">
              <span className="text-white font-bold text-base">GIGA</span>
            </div>
          </Link>
          <FaTimes 
            className='text-2xl cursor-pointer text-gray-600 hover:text-gray-900 transition-colors' 
            onClick={toggleSidebar} 
          />
        </div>
        <div className='relative p-4'>
          <Input
            type="text"
            placeholder='Search cars, models...'
            className='w-full shadow-sm'
            value={searchQuery}
            onChange={handleInputChange}
            onKeyDown={handleKeyDown}
          />
          <AiOutlineSearch 
            className='absolute top-1/2 right-8 transform -translate-y-1/2 text-gray-400 cursor-pointer hover:text-red-600 transition-colors z-10' 
            size={20} 
            onClick={onSearch}
          />
        </div>
        <ul className='flex flex-col gap-2 p-4'>
          <Link to="/">
            <li 
              className='hover:bg-red-50 hover:text-[#DC2626] cursor-pointer font-medium transition-all duration-200 py-3 px-4 rounded-lg' 
              onClick={toggleSidebar}
            >
              Home
            </li>
          </Link>
          <Link to="/cars">
            <li 
              className='hover:bg-red-50 hover:text-[#DC2626] cursor-pointer font-medium transition-all duration-200 py-3 px-4 rounded-lg' 
              onClick={toggleSidebar}
            >
              Car Deals
            </li>
          </Link>
          <Link to="/rental">
            <li 
              className='hover:bg-red-50 hover:text-[#DC2626] cursor-pointer font-medium transition-all duration-200 py-3 px-4 rounded-lg' 
              onClick={toggleSidebar}
            >
              Rental
            </li>
          </Link>
          <Link to="/workshop">
            <li 
              className='hover:bg-red-50 hover:text-[#DC2626] cursor-pointer font-medium transition-all duration-200 py-3 px-4 rounded-lg' 
              onClick={toggleSidebar}
            >
              Workshop
            </li>
          </Link>
          <Link to="/blog/66c6f093dc2c7f86bdc18469">
            <li 
              className='hover:bg-red-50 hover:text-[#DC2626] cursor-pointer font-medium transition-all duration-200 py-3 px-4 rounded-lg' 
              onClick={toggleSidebar}
            >
              Contact Us
            </li>
          </Link>
          <Link to="/blog/66c6eeef6fd2b5788b909128">
            <li 
              className='hover:bg-red-50 hover:text-[#DC2626] cursor-pointer font-medium transition-all duration-200 py-3 px-4 rounded-lg' 
              onClick={toggleSidebar}
            >
              About Us
            </li>
          </Link>
        </ul>

        {/* Mobile Sidebar Footer with Social Media Icons */}
        <div className='absolute bottom-0 left-0 right-0 flex justify-center gap-6 p-6 border-t border-gray-200 bg-gray-50'>
          <a href="https://www.facebook.com" target="_blank" rel="noopener noreferrer">
            <div className='bg-[#1877F2] p-2.5 rounded-full hover:bg-[#166fe5] transition-all duration-300 hover:scale-110 shadow-md'>
              <FaFacebookF className='text-white text-lg cursor-pointer' />
            </div>
          </a>
          <a href="https://www.twitter.com" target="_blank" rel="noopener noreferrer">
            <div className='bg-[#1DA1F2] p-2.5 rounded-full hover:bg-[#1a91da] transition-all duration-300 hover:scale-110 shadow-md'>
              <FaTwitter className='text-white text-lg cursor-pointer' />
            </div>
          </a>
          <a href="https://www.instagram.com" target="_blank" rel="noopener noreferrer">
            <div className='bg-gradient-to-r from-[#F58529] via-[#DD2A7B] to-[#833AB4] p-2.5 rounded-full hover:opacity-90 transition-all duration-300 hover:scale-110 shadow-md'>
              <FaInstagram className='text-white text-lg cursor-pointer' />
            </div>
          </a>
        </div>
      </div>
    </>
  );
};

export default Header;
